import { createContext } from 'react';

const checklistContext = createContext();

export default checklistContext;